<template>
  <section>
    <img src="../../../assets/Logotipo_MasterdaWeb-02.svg" class="logo-img-svg" alt="masterdaweb-logo">

    <div class="card">
      <!-- <vuestic-pre-loader v-show="isLoading" class="pre-loader"></vuestic-pre-loader> -->
      <semipolar-spinner v-show="isLoading" :animation-duration="2000" :size="140" color="#7643C9" class="pre-loader" />

      <div class="buy-container" v-show="!isLoading">
        <Order :offline="true" />
      </div>
    </div>

  </section>
</template>

<script>
import Order from '@/components/order/Order'
import { SemipolarSpinner } from 'epic-spinners'
import {mapGetters} from 'vuex'

  export default {
    name: 'buy',
    data () {
      return {
        url: {},
      }
    },
    components: {
      Order,
      SemipolarSpinner
    },
    computed:{
      ...mapGetters([
        'isLoading'
      ]),
    }
  }
</script>

<style scoped lang="scss">

@import "../../../sass/_variables.scss";

section{
  background: #0d1025;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 100vh;
}
.logo{
  width: 350px;
  height: 250px;
  font-size: 100px;
  color: #fff;
}
h2{
  margin: 10px;
}
.card {
  display: flex;
  border: 1px solid black;
  padding: 68px;
  border-radius: 15px;
  width: 80%;
  min-height: 40vh;
}
.card > div {
  height: 100%;
}

.btn{
  padding: 20px 68px;
  font-weight: bold;
}
.btn-white{
  color: #7643C9;
  background: #fff;
}
.btn-white:hover{
  color: #fff;
  background: #420679;
}
.btn-purple{
  background: #7643C9;
}
.btn-purple:hover{
  background: #420679;
}
.text-white, .text-white > a{
  color: #fff;
  margin-top: 20px;
}
.pre-loader {
  position: absolute;
  left: $vuestic-preloader-left;
  top: $vuestic-preloader-top;
}

@media only screen and (max-width: 992px) {
  .card{
    padding: 5px;
    width: 100%;
  }

  .logo{
    width: 250px;
    margin-bottom: 10px;
  }

  h3{
    font-size: 1.5em;
  }
  .buy-container {
    width: 100%;
    border: 0px;
    border-radius: 0px;
    padding: 1.5rem;
  }
}

@media only screen and (min-width: 992px) {
  .buy-container {
    max-width: 70%
  }
}


</style>



// WEBPACK FOOTER //
// src/components/auth/purchase/buy.vue